import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

export function useAuthFetch() {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  return useCallback(
    async (url: string, options: RequestInit = {}) => {
      let token: string;
      try {
        token = await getAccessTokenSilently();
      } catch (error: unknown) {
        const code = (error as Record<string, unknown>)?.error as string | undefined;
        if (code === 'consent_required' || code === 'login_required') {
          await loginWithRedirect({ appState: { returnTo: window.location.pathname } });
          throw error;
        }
        throw error;
      }

      const apiBase = import.meta.env.VITE_API_BASE_URL as string;
      const fullUrl = url.startsWith('http') ? url : `${apiBase}${url}`;

      return fetch(fullUrl, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
          Authorization: `Bearer ${token}`,
        },
      });
    },
    [getAccessTokenSilently, loginWithRedirect]
  );
}
